import {
  Box,
  Stack,
  Drawer,
  Button,
  Divider,
  useTheme,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';

import Iconify from '../iconify';

interface Props {
  open?: boolean;
  onClose?: () => void;
  handleClearFilters?: () => void;
  handleApplyFilters?: () => void;
  children?: React.ReactNode;
}

export function FilterSidebar({ open, onClose, handleClearFilters, handleApplyFilters, children }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : 480,
          border: 'none',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h4">Filters</Typography>
        <IconButton onClick={onClose} aria-label="Close filters">
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Box>

      <Divider />

      <Box sx={{ p: 3, overflow: 'auto', height: '100%' }}>{children}</Box>

      <Box sx={{ p: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
        <Stack direction="row" spacing={2}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleClearFilters}
            startIcon={<Iconify icon="eva:trash-2-outline" />}
          >
            Clear
          </Button>
          {handleApplyFilters ? (
            <Button
              fullWidth
              variant="contained"
              onClick={handleApplyFilters}
              startIcon={<Iconify icon="eva:funnel-fill" />}
            >
              Apply Filters
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              onClick={onClose}
              startIcon={<Iconify icon="eva:checkmark-outline" />}
            >
              Done
            </Button>
          )}
        </Stack>
      </Box>
    </Drawer>
  );
}
